import React, { useRef, useState } from "react";
import Avatar2 from "../../../assets/Avatar7.png";
import { BsDisplay } from "react-icons/bs";
import { FiLogOut } from "react-icons/fi";
// import { FaGithub, FaLinkedinIn } from "react-icons/fa";
// import { IoLogoLinkedin } from "react-icons/io5";
function ManagerUserProfilePersonalInfo() {
  const options = ["Phone", "Email"];
  const [notificationSettings, setNotificationSettings] = useState({
    PushStatus: false,
    EmailStatus: false,
    PushCandidate: false,
    EmailCandidate: false,
    PushAlert: false,
    EmailAlert: false,
    PushAI: false,
    EmailAI: false,
  });
  const [formData, setFormData] = useState({
    current: "",
    newPass: "",
    confirm: "",
  });
  const fileInputRef = useRef(null);
  const handleDivClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  return (
    <div className="flex self-stretch justify-start items-start flex-col gap-8 pt-4">
      <div className="flex self-stretch justify-start items-start flex-col gap-6">
        <div className="flex self-stretch justify-start items-start flex-col gap-5">
          <div className="flex flex-wrap self-stretch justify-start items-start flex-row gap-y-4 gap-x-8">
            <div className="min-w-[200px] max-w-[280px] flex flex-1 justify-start items-start flex-col">
              <div className="flex justify-start items-center flex-row gap-0.5">
                <span className="text-[#414651] text-sm  font-semibold">
                  Personal info
                </span>
              </div>
              <p className="self-stretch text-[#535862] text-sm ">
                Update your photo and personal details.
              </p>
            </div>
            <div className="min-w-[360px] max-w-[720px] flex flex-1 justify-start items-start flex-col bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
              <div className="flex self-stretch justify-start items-start flex-col gap-6 p-[24px]">
                <div className="flex self-stretch justify-start items-start flex-row gap-6">
                  <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
                    <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                      <div className="flex justify-start items-start flex-row gap-0.5">
                        <span className="text-[#414651] text-sm  font-medium">
                          First name
                        </span>
                        <span className="text-[#009C97] text-sm  font-medium">
                          *
                        </span>
                      </div>
                      <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                        <div className="flex flex-1 justify-start items-center flex-row gap-2">
                          {/* <p className="flex-1 text-[#181D27] ">
                                      Olivia
                                    </p> */}
                          <input
                            type="text"
                            placeholder="First name.."
                            className=" outline-none w-full text-gray-600"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
                    <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                      <div className="flex justify-start items-start flex-row gap-0.5">
                        <span className="text-[#414651] text-sm  font-medium">
                          Last name
                        </span>
                        <span className="text-[#009C97] text-sm  font-medium">
                          *
                        </span>
                      </div>
                      <div className="flex self-stretch justify-start items-center flex-row gap-2 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                        <div className="flex flex-1 justify-start items-center flex-row gap-2">
                          <input
                            type="text"
                            placeholder="Last name.."
                            className=" outline-none w-full text-gray-600"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                  <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                    <div className="flex justify-start items-start flex-row gap-0.5">
                      <span className="text-[#414651] text-sm  font-medium">
                        Phone Number
                      </span>
                      <span className="text-[#009C97] text-sm  font-medium">
                        *
                      </span>
                    </div>
                    <div className="flex self-stretch justify-start items-start flex-row bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                      <div className="flex self-stretch justify-start items-center text-gray-700 gap-1 py-2.5 pl-3.5">
                        <select>
                          <option value="UK" className="text-gray-600">
                            UK (+44)
                          </option>
                        </select>
                      </div>
                      <div className="flex flex-1 justify-start items-center flex-row gap-2 py-2.5 pr-3.5 pl-3">
                        <input
                          type="tel"
                          placeholder="07123 456789"
                          className="text-gray-700 w-full outline-none"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex self-stretch justify-start items-start flex-row gap-5">
                  <div className="flex justify-center items-center flex-row rounded-full ">
                    <img src={Avatar2} alt="" />
                  </div>
                  <div className="flex flex-1 justify-start items-start flex-col gap-4">
                    <div
                      onClick={handleDivClick}
                      className="flex self-stretch cursor-pointer justify-start items-center flex-col gap-1 py-4 px-[24px] bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl"
                    >
                      <div className="flex self-stretch justify-start items-center flex-col gap-3">
                        <div
                          className="flex justify-center items-center flex-row p-2.5 bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),inset_0px_0px_0px_1px_rgba(10,13,18,0.18)] w-[40px] h-[40px]"
                          style={{ width: "40px" }}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.66669 13.3333L10 10M10 10L13.3334 13.3333M10 10V17.5M16.6667 13.9524C17.6846 13.1117 18.3334 11.8399 18.3334 10.4167C18.3334 7.88536 16.2813 5.83333 13.75 5.83333C13.5679 5.83333 13.3976 5.73833 13.3051 5.58145C12.2184 3.73736 10.212 2.5 7.91669 2.5C4.46491 2.5 1.66669 5.29822 1.66669 8.75C1.66669 10.4718 2.36289 12.0309 3.48914 13.1613"
                              stroke="#414651"
                              strokeWidth="1.66667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="flex self-stretch justify-start items-center flex-col gap-1">
                          <div className="flex self-stretch justify-center items-start flex-row gap-1">
                            <div className="flex justify-center items-center flex-row gap-1.5">
                              <span className="text-[#009C97] text-sm  font-semibold">
                                Click to upload
                              </span>
                            </div>
                            <span className="text-[#535862] text-sm ">
                              or drag and drop
                            </span>
                          </div>
                          <p className="self-stretch text-[#535862] text-xs  text-center">
                            SVG, PNG, JPG or GIF (max. 800x400px)
                          </p>
                        </div>
                        <input
                          type="file"
                          ref={fileInputRef}
                          accept="image/png. , image/jpeg,image/gif,image/svg+xml"
                          className="hidden"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex self-stretch justify-start items-center flex-col gap-4 pb-4 border-t border-gray-200 pt-4">
                <div className="flex self-stretch justify-end items-center flex-row gap-4 px-[24px]">
                  <div className="flex flex-1 justify-end items-center flex-row gap-3">
                    <div className="flex justify-center items-center flex-row gap-1 py-2.5 px-3.5 border border-gray-300 rounded-lg  cursor-pointer">
                      <div className="flex justify-center items-center flex-row px-0.5">
                        <span className="text-[#414651] text-sm  font-semibold">
                          Cancel
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-center items-center flex-row gap-1 py-2.5 px-3.5 bg-[#009C97] border-solid border-[undefined] border-2 rounded-lg cursor-pointer">
                      <div className="flex justify-center items-center flex-row px-0.5">
                        <span className="text-[#FFFFFF] text-sm  font-semibold">
                          Save changes
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="self-stretch bg-[#E9EAEB] h-px"></div>
          <div className="flex flex-wrap self-stretch justify-start items-start flex-row gap-y-4 gap-x-8">
            <div className="min-w-[200px] max-w-[280px] flex flex-1 justify-start items-start flex-col">
              <div className="flex justify-start items-center flex-row gap-0.5">
                <span className="text-[#414651] text-sm  font-semibold">
                  Notification settings
                </span>
              </div>
              <p className="self-stretch text-[#535862] text-sm ">
                We may still send you important notifications about your account
                outside of your notification settings.
              </p>
            </div>
            <div className="min-w-[320px] max-w-[720px] flex flex-1 justify-start items-start flex-col bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
              <div className="flex self-stretch justify-start items-start flex-col gap-6 p-[24px]">
                <form
                  action=""
                  className="w-full flex items-start gap-5 flex-col"
                >
                  <div className="flex items-start w-full border border-b-gray-200 pb-6">
                    <h2 className="text-gray-800 text-sm font-semibold w-2/3 ">
                      Job Status
                    </h2>
                    <div className="flex flex-col items-start gap-4">
                      {options.map((option) => {
                        const key = `${option}Status`;
                        return (
                          <div key={key} className="flex items-center gap-3">
                            <div
                              onClick={() =>
                                setNotificationSettings((prev) => ({
                                  ...prev,
                                  [key]: !prev[key],
                                }))
                              }
                              className={`w-10 h-5 rounded-full shadow-sm relative transition-colors duration-300 ease-in-out ${
                                notificationSettings[key]
                                  ? "bg-[#19BFB7]"
                                  : "bg-gray-100"
                              } px-[3px] cursor-pointer`}
                            >
                              <span
                                className={`rounded-full w-3 h-3 transition-transform duration-200 bg-white ${
                                  notificationSettings[key]
                                    ? "translate-x-5"
                                    : "translate-x-0"
                                } shadow-sm absolute -translate-y-1/2 top-1/2`}
                              ></span>
                            </div>
                            <p className="text-gray-800 text-sm font-semibold">
                              {option}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  {/*  */}
                  <div className="flex items-start w-full border border-b-gray-200 pb-6">
                    <h2 className="text-gray-800 text-sm font-semibold w-2/3 ">
                      Candidate Applications
                    </h2>
                    <div className="flex flex-col items-start gap-4">
                      {options.map((option) => {
                        const key = `${option}Candidate`;
                        return (
                          <div key={key} className="flex items-center gap-3">
                            <div
                              onClick={() =>
                                setNotificationSettings((prev) => ({
                                  ...prev,
                                  [key]: !prev[key],
                                }))
                              }
                              className={`w-10 h-5 rounded-full shadow-sm relative transition-colors duration-300 ease-in-out ${
                                notificationSettings[key]
                                  ? "bg-[#19BFB7]"
                                  : "bg-gray-100"
                              } px-[3px] cursor-pointer`}
                            >
                              <span
                                className={`rounded-full w-3 h-3 transition-transform duration-200 bg-white ${
                                  notificationSettings[key]
                                    ? "translate-x-5"
                                    : "translate-x-0"
                                } shadow-sm absolute -translate-y-1/2 top-1/2`}
                              ></span>
                            </div>
                            <p className="text-gray-800 text-sm font-semibold">
                              {option}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  {/*  */}
                  <div className="flex items-start w-full border border-b-gray-200 pb-6">
                    <h2 className="text-gray-800 text-sm font-semibold w-2/3 ">
                      Alert
                    </h2>
                    <div className="flex flex-col items-start gap-4">
                      {options.map((option) => {
                        const key = `${option}Alert`;
                        return (
                          <div key={key} className="flex items-center gap-3">
                            <div
                              onClick={() =>
                                setNotificationSettings((prev) => ({
                                  ...prev,
                                  [key]: !prev[key],
                                }))
                              }
                              className={`w-10 h-5 rounded-full shadow-sm relative transition-colors duration-300 ease-in-out ${
                                notificationSettings[key]
                                  ? "bg-[#19BFB7]"
                                  : "bg-gray-100"
                              } px-[3px] cursor-pointer`}
                            >
                              <span
                                className={`rounded-full w-3 h-3 transition-transform duration-200 bg-white ${
                                  notificationSettings[key]
                                    ? "translate-x-5"
                                    : "translate-x-0"
                                } shadow-sm absolute -translate-y-1/2 top-1/2`}
                              ></span>
                            </div>
                            <p className="text-gray-800 text-sm font-semibold">
                              {option}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  {/*  */}
                  <div className="flex items-start w-full ">
                    <h2 className="text-gray-800 text-sm font-semibold w-2/3 ">
                      AI insights
                    </h2>
                    <div className="flex flex-col items-start gap-4">
                      {options.map((option) => {
                        const key = `${option}AI`;
                        return (
                          <div key={key} className="flex items-center gap-3">
                            <div
                              onClick={() =>
                                setNotificationSettings((prev) => ({
                                  ...prev,
                                  [key]: !prev[key],
                                }))
                              }
                              className={`w-10 h-5 rounded-full shadow-sm relative transition-colors duration-300 ease-in-out ${
                                notificationSettings[key]
                                  ? "bg-[#19BFB7]"
                                  : "bg-gray-100"
                              } px-[3px] cursor-pointer`}
                            >
                              <span
                                className={`rounded-full w-3 h-3 transition-transform duration-200 bg-white ${
                                  notificationSettings[key]
                                    ? "translate-x-5"
                                    : "translate-x-0"
                                } shadow-sm absolute -translate-y-1/2 top-1/2`}
                              ></span>
                            </div>
                            <p className="text-gray-800 text-sm font-semibold">
                              {option}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </form>
              </div>
              <div className="flex self-stretch justify-start items-center flex-col gap-4 pb-4 border-t border-gray-200 pt-4">
                <div className="flex items-center justify-end w-full gap-3 px-6">
                  <button className="bg-[#009C97] text-white rounded-lg px-3 py-1.5 cursor-pointer font-semibold text-sm">
                    Save changes
                  </button>
                  <button className=" text-gray-700 border border-gray-300 hover:bg-gray-100 transition duration-150 rounded-lg px-3 py-1.5 cursor-pointer font-semibold text-sm">
                    Cancle
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="self-stretch bg-[#E9EAEB] h-px"></div>
          {/* password */}
          <div className="flex flex-wrap self-stretch justify-start items-start flex-row gap-y-4 gap-x-8 ">
            <div className="min-w-[200px] max-w-[280px] flex flex-1 justify-start items-start flex-col">
              <div className="flex justify-start items-center flex-row gap-0.5">
                <span className="text-[#414651] text-sm  font-semibold">
                  Password
                </span>
              </div>
              <p className="self-stretch text-[#535862] text-sm ">
                Please enter your current password to change your password.
              </p>
            </div>
            <div className="min-w-[320px] max-w-[720px] flex flex-1 justify-start items-start flex-col bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
              <div className="flex self-stretch justify-start items-start flex-col gap-6 p-[24px]">
                <form
                  action=""
                  className="w-full flex items-start gap-5 flex-col"
                >
                  <div className="w-full pb-8 border-b border-gray-200 flex items-start ">
                    <label className="text-[#414651] text-sm  font-medium w-1/2">
                      Current password
                      <span className="text-[#009C97] text-sm  font-medium">
                        *
                      </span>
                    </label>
                    <div className="flex flex-col gap-1 w-full">
                      <input
                        type="password"
                        value={formData.current}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            current: e.target.value,
                          }))
                        }
                        className="w-full p-2 rounded-lg border border-gray-200 outline-none text-gray-700"
                      />
                      {formData.current.length > 0 &&
                        formData.current.length < 8 && (
                          <p className="text-red-500 text-xs mt-1">
                            Password must be at least 8 characters.
                          </p>
                        )}
                    </div>
                  </div>
                  {/*  */}
                  <div className="w-full pb-8 border-b border-gray-200 flex items-start ">
                    <label className="text-[#414651] text-sm  font-medium w-1/2">
                      New password
                      <span className="text-[#009C97] text-sm  font-medium">
                        *
                      </span>
                    </label>
                    <div className="flex flex-col gap-1 w-full">
                      <input
                        type="password"
                        value={formData.newPass}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            newPass: e.target.value,
                          }))
                        }
                        className="w-full p-2 rounded-lg border border-gray-200 outline-none text-gray-700"
                      />
                      {formData.newPass.length > 0 &&
                        formData.newPass.length < 8 && (
                          <p className="text-red-500 text-xs mt-1">
                            Password must be at least 8 characters.
                          </p>
                        )}
                    </div>
                  </div>
                  {/*  */}
                  <div className="w-full flex items-start ">
                    <label className="text-[#414651] text-sm  font-medium w-1/2">
                      Confirm new password
                      <span className="text-[#009C97] text-sm  font-medium">
                        *
                      </span>
                    </label>
                    <input
                      type="password"
                      className="w-full p-2 rounded-lg border border-gray-200 outline-none text-gray-700"
                    />
                  </div>
                </form>
              </div>
              <div className="flex self-stretch justify-start items-center flex-col gap-4 pb-4 border-t border-gray-200 pt-4">
                <div className="flex items-center justify-end w-full gap-3 px-6">
                  <button className="bg-[#009C97] text-white rounded-lg px-3 py-1.5 cursor-pointer font-semibold text-sm">
                    Save changes
                  </button>
                  <button className=" text-gray-700 border border-gray-300 hover:bg-gray-100 transition duration-150 rounded-lg px-3 py-1.5 cursor-pointer font-semibold text-sm">
                    Cancle
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="self-stretch bg-[#E9EAEB] h-px"></div>
          {/* logged in */}
          <div className="flex flex-wrap self-stretch justify-start items-start flex-row gap-y-4 gap-x-8 ">
            <div className="min-w-[200px] max-w-[280px] flex flex-1 justify-start items-start flex-col">
              <div className="flex justify-start items-center flex-row gap-0.5">
                <span className="text-[#414651] text-sm  font-semibold">
                  Where you're logged in
                </span>
              </div>
              <p className="self-stretch text-[#535862] text-sm ">
                We'll alert you via olivia@untitledui.com if there is any
                unusual activity on your account.
              </p>
            </div>
            <div className="min-w-[320px] p-6 max-w-[720px] flex gap-6 flex-1 justify-start items-start flex-col bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
              <div className="flex items-start justify-start gap-4 w-full border-b border-gray-200 pb-6">
                <BsDisplay className="w-7 h-7 text-gray-800 " />
                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-3">
                    <h2 className="text-sm text-gray-700 font-semibold">
                      2024 MacBook Pro 14-inch
                    </h2>
                    <div className="border border-gray-200 rounded-lg px-2 py-1 flex items-center gap-1.5">
                      <span className="w-2 h-2 rounded-full bg-green-600"></span>
                      <span className="text-gray-600 text-xs font-semibold">
                        Active now
                      </span>
                    </div>
                  </div>
                  <p className="flex max-[420px]:flex-col max-[420px]:items-start items-center gap-2 text-gray-700">
                    <span className="text-sm text-gray-700 font-normal">
                      Melbourne, Australia
                    </span>
                    <span className="max-[420px]:hidden"> &bull;</span>
                    <span className="text-sm text-gray-700 font-normal">
                      22 Jan at 10:40am
                    </span>
                  </p>
                </div>
              </div>
              {/*  */}
              <div className="flex items-center justify-between w-full  ">
                <div className="flex items-start justify-start gap-4 w-2/3 ">
                  <BsDisplay className="w-7 h-7 text-gray-800 " />
                  <div className="flex flex-col gap-2">
                    <div className="flex items-center gap-3">
                      <h2 className="text-sm text-gray-700 font-semibold">
                        2024 MacBook Pro 14-inch
                      </h2>
                    </div>
                    <p className="flex max-[420px]:flex-col max-[420px]:items-start items-center gap-2 text-gray-700">
                      <span className="text-sm text-gray-700 font-normal">
                        Melbourne, Australia
                      </span>
                      <span className="max-[420px]:hidden"> &bull;</span>
                      <span className="text-sm text-gray-700 font-normal">
                        22 Jan at 10:40am
                      </span>
                    </p>
                  </div>
                </div>
                <button className="text-red-600 flex items-center gap-2 cursor-pointer font-semibold text-sm px-3">
                  <FiLogOut className="w-5 h-6" />
                  Sign out
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ManagerUserProfilePersonalInfo;